<template>
  <ValidationProvider :rules="rules"
                      :custom-messages="customMessages"
                      tag="div"
                      :name="name"
                      v-slot="{ errors }"
                      ref="provider"
  >
    <DateTimePicker v-model="inputVal"
                    :label="label"
                    :min="min"
                    :max="max"
                    :disabled="disabled"
                    :has-time="hasTime"
                    :has-range="hasRange"
                    :use12h="use12h"
                    :has-short-cuts="hasShortCuts"
                    :custom-shortcuts="shortcuts"
                    :placeholder="placeholder"
                    :dateLabel="dateLabel"
                    :timeLabel="timeLabel"
                    @touched="handleTouched"
                    :default-time="defaultTime"
    ></DateTimePicker>
    <b-form-invalid-feedback :state="state(errors)">
      {{ errors[0] }}
    </b-form-invalid-feedback>
  </ValidationProvider>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    DateTimePicker,
    BFormInvalidFeedback,
  },
  props: {
    min: {
      type: Date,
      default: null,
    },
    max: {
      type: Date,
      default: null,
    },
    hasTime: Boolean,
    customMessages: Object,
    use12h: {
      type: Boolean,
      default: true,
    },
    hasRange: {
      type: Boolean,
      default: false,
    },
    shortcuts: Array,
    hasShortCuts: Boolean,
    placeholder: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    defaultTime: String,
  },
  methods: {
    handleTouched() {
      this.$refs.provider.setFlags({
        touched: true,
        untouched: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-date {
  .d-block {
    float: left;
  }
}
</style>
